import React from 'react'
import { Edit } from 'react-admin'

import EventsForm from './form'

export const EventsEdit = (props) => (
  <Edit undoable={false} {...props}>
    <EventsForm {...props} />
  </Edit>
)

export default EventsEdit
